var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6652 8.80716C16.1116 8.36071 16.1116 7.63567 15.6652 7.18922L9.95055 1.47461C9.5041 1.02816 8.77906 1.02816 8.33261 1.47461C7.88615 1.92106 7.88615 2.6461 8.33261 3.09256L12.1007 6.85705H1.14292C0.510743 6.85705 0 7.3678 0 7.99997C0 8.63215 0.510743 9.1429 1.14292 9.1429H12.0971L8.33618 12.9074C7.88973 13.3538 7.88973 14.0789 8.33618 14.5253C8.78263 14.9718 9.50767 14.9718 9.95413 14.5253L15.6687 8.81073L15.6652 8.80716Z",
    fill: "#2E3285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/arrow-right-blue.d0e3edbf1a0aa00d66d3cfe773daa5bb.svg";
export { ForwardRef as ReactComponent };